import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { useDeletePensionDialogueData } from '../../../api/pension-robot/useDeletePensionDialogueData';
import { useGetPensionDialogueData } from '../../../api/pension-robot/useGetPensionDialogueData';
import { usePostDialogueData } from '../../../api/pension-robot/usePostPensionDialogueData';
import { RobotEnvironmentContext } from '../../../contexts/general/RobotEnvironmentContext';


export const SavingButtons = () => {
    const enviromentVars = useContext(RobotEnvironmentContext);

    const GetSaveButton = () => {
        if ( enviromentVars.environment !== "Marketing"
            || !enviromentVars.userToken )
            return <></>;

        return <SaveDataButton userToken={enviromentVars.userToken}/>
    }

    const GetLoadButton = () => {
        if ( !enviromentVars.userToken )
            return <></>;

        return <LoadDataButton userToken={enviromentVars.userToken}/>
    }

    const GetDeleteButton = () => {
        if ( !enviromentVars.userToken )
            return <></>;

        return <DeleteDataButton userToken={enviromentVars.userToken}/>
    }

    return (
        <>
            <GetSaveButton/>
            <GetLoadButton/>
            <GetDeleteButton/>
        </>
    )
}

export const SaveDataButton: React.FC<{userToken: string}> = () => {
    const { t } = useTranslation('pension');
    const responseQueryOrUndefined = usePostDialogueData();

    const onClick = () => {
        if (responseQueryOrUndefined !== undefined)
            responseQueryOrUndefined.refetch()
    }

    return (
        <div>
            <span className="text-bnd-pink underline cursor-pointer" onClick={onClick}>
                {t('general-save')}
            </span>
        </div>
    );
}

export const LoadDataButton: React.FC<{userToken: string}> = () => {
    const { t } = useTranslation('pension');
    const query = useGetPensionDialogueData();
    
    return (
        <div>
            <span className="text-bnd-green underline cursor-pointer" onClick={() => query.refetch()}>
                {t('general-retrieve')}
            </span>
        </div>
    );
};

export const DeleteDataButton: React.FC<{userToken: string}> = () => {
    const { t } = useTranslation('pension');
    const deleteQuery = useDeletePensionDialogueData();

    const onClick = () => {
        deleteQuery.refetch();
    }

    return (
        <div>
            <span className="text-bnd-red underline cursor-pointer" onClick={onClick}>
                {t('general-delete')}
            </span>
        </div>
    );
};

